import React from 'react';
import theme from 'utils/theme';

const options = [
    {
        name: 'gren300',
        background: theme.colors.green300,
        color: theme.colors.black
    },
    {
        name: 'yellow',
        background: theme.colors.yellow400,
        color: theme.colors.black
    },
    {
        name: 'rose300',
        background: theme.colors.rose300,
        color: theme.colors.black
    },
    {
        name: 'blue',
        background: theme.colors.blue200,
        color: theme.colors.black
    },
    {
        name: 'caramel',
        background: theme.colors.caramel400,
        color: theme.colors.white
    },
    {
        name: 'green600',
        background: theme.colors.green600,
        color: theme.colors.white
    },
    {
        name: 'grey600',
        background: theme.colors.black,
        color: theme.colors.white
    }
];

export default function ImagePlaceholder({ color, text }) {
    return (
        <div className="image-placeholder">
            <div className="background" style={{ background: options[color]?.background || theme.colors.green300, color: options[color]?.color || theme.colors.black }}>
                <h1 className="noselect">GiftCard</h1>
                <h2 style={{ color: options[color]?.color || theme.colors.black }} className="noselect">{text}</h2>
            </div>
        </div>
    )
}
